import Card from "@material-ui/core/Card";
import { CategoryDetails_category } from "@saleor/categories/types/CategoryDetails";
import { CollectionDetails_collection } from "@saleor/collections/types/CollectionDetails";
import RecommendProductList from "@saleor/components/RecommendProductList";
import { Tab, TabContainer } from "@saleor/components/Tab";
import useNavigator from "@saleor/hooks/useNavigator";
import { ProductDetails_product } from "@saleor/products/types/ProductDetails";
import { productUrl } from "@saleor/products/urls";
import { TabListActions } from "@saleor/types";
import {
  RecommendationTargetTypeEnum,
  RecommendationTypeEnum
} from "@saleor/types/globalTypes";
import React from "react";
import { FormattedMessage } from "react-intl";

export enum RecommendProductTab {
  recommends = "Recommendation",
  also_likes = "Also Like",
  buy_together = "Buy Together"
}

export interface RecommendProductSectionProps
  extends TabListActions<
    "recommendToolbar" | "alsolikeToolbar" | "buytogetherToolbar"
  > {
  disabled: boolean;
  isBuytogether?: boolean;
  // changeTab: (index: RecommendProductTab) => void;
  // currentTab: RecommendProductTab;
  target:
    | ProductDetails_product
    | CategoryDetails_category
    | CollectionDetails_collection;
  targetType: RecommendationTargetTypeEnum;
  onRecommendAssign: () => void;
  onAlsolikeAssign: () => void;
  onBuytogetherAssign?: () => void;
  onRecommendUnassign: (id: string, event: React.MouseEvent<any>) => void;
  onAlsolikeUnassign: (id: string, event: React.MouseEvent<any>) => void;
  onBuytogetherUnAssign?: (id: string, event: React.MouseEvent<any>) => void;
}

const RecommandsTab = Tab(RecommendProductTab.recommends);
const AlsoLikeTab = Tab(RecommendProductTab.also_likes);
const BuyTogetherTab = Tab(RecommendProductTab.buy_together);

const RecommendProductSection: React.FC<RecommendProductSectionProps> = props => {
  const {
    disabled,
    isBuytogether,
    // changeTab,
    target,
    targetType,
    // currentTab,
    onRecommendAssign,
    onAlsolikeAssign,
    onBuytogetherAssign,
    onRecommendUnassign,
    onAlsolikeUnassign,
    onBuytogetherUnAssign,
    isChecked,
    selected,
    toggle,
    toggleAll,
    recommendToolbar,
    alsolikeToolbar,
    buytogetherToolbar
  } = props;
  const navigate = useNavigator();

  const [currentTab, setchangeTab] = React.useState(
    RecommendProductTab.recommends
  );

  const changeTab = (tabName: RecommendProductTab) => {
    setchangeTab(tabName);
  };

  return (
    <Card>
      <TabContainer>
        <RecommandsTab
          isActive={currentTab === RecommendProductTab.recommends}
          changeTab={changeTab}
        >
          <FormattedMessage
            defaultMessage="Recommendation"
            description="number of recommends in product"
          />
        </RecommandsTab>
        <AlsoLikeTab
          isActive={currentTab === RecommendProductTab.also_likes}
          changeTab={changeTab}
        >
          <FormattedMessage
            defaultMessage="Also Like"
            description="number of also likes in product"
          />
        </AlsoLikeTab>
        {isBuytogether && (
          <BuyTogetherTab
            isActive={currentTab === RecommendProductTab.buy_together}
            changeTab={changeTab}
          >
            <FormattedMessage
              defaultMessage="Buy Together"
              description="number of Buy Together in product"
            />
          </BuyTogetherTab>
        )}
      </TabContainer>
      {currentTab === RecommendProductTab.recommends && (
        <RecommendProductList
          disabled={disabled}
          target={target}
          targetType={targetType}
          tabName={currentTab}
          products={target?.recommendProducts}
          recommendType={RecommendationTypeEnum.RECOMMEND}
          onRowClick={id => () => navigate(productUrl(id))}
          onProductAdd={onRecommendAssign}
          onProductUnassign={onRecommendUnassign}
          toolbar={recommendToolbar}
          isChecked={isChecked}
          selected={selected}
          toggle={toggle}
          toggleAll={toggleAll}
        />
      )}
      {currentTab === RecommendProductTab.also_likes && (
        <RecommendProductList
          disabled={disabled}
          target={target}
          targetType={targetType}
          tabName={currentTab}
          products={target?.alsoLikeProducts}
          recommendType={RecommendationTypeEnum.ALSO_LIKE}
          onRowClick={id => () => navigate(productUrl(id))}
          onProductAdd={onAlsolikeAssign}
          onProductUnassign={onAlsolikeUnassign}
          toolbar={alsolikeToolbar}
          isChecked={isChecked}
          selected={selected}
          toggle={toggle}
          toggleAll={toggleAll}
        />
      )}
      {currentTab === RecommendProductTab.buy_together && (
        <RecommendProductList
          disabled={disabled}
          target={target}
          targetType={targetType}
          tabName={currentTab}
          products={target?.buyTogetherProducts}
          recommendType={RecommendationTypeEnum.BUY_TOGETHER}
          onRowClick={id => () => navigate(productUrl(id))}
          onProductAdd={onBuytogetherAssign}
          onProductUnassign={onBuytogetherUnAssign}
          toolbar={buytogetherToolbar}
          isChecked={isChecked}
          selected={selected}
          toggle={toggle}
          toggleAll={toggleAll}
        />
      )}
    </Card>
  );
};

RecommendProductSection.displayName = "RecommendProductSection";
export default RecommendProductSection;
